import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { CampaignStyleProps } from './Campaign.interface';

export const Row = styled.div<CampaignStyleProps>`
    width: 940px;
    box-sizing: border-box;
    margin: 0 auto ${({ theme }) => theme.spacing * 3}px;;
    padding: 0 ${({ theme }) => theme.spacing * 6}px;
    min-height: 44px;
    border-radius: 6px;
    display: grid;
    grid-template-columns: auto 30px;
    background-color: ${({ theme }) => theme.colors.paleBlue};
    cursor: pointer;
    > a {
        display: grid;
        align-items: center;
        padding: ${({ theme }) => theme.spacing * 2}px 0;
        grid-column-gap: ${({ theme }) => theme.spacing * 4}px;
        grid-template-columns: ${props => props.adminAccess
            ? '95px 156px 220px 115px 90px 90px'
            : '231px 220px 115px 90px 110px'
        };
        > p {
            font-size: 14px;
            margin: 0;
            color: ${({ theme }) => theme.colors.blue};
            opacity: .87;
            word-break: break-all;
        }
    }
    > .MuiButtonBase-root  {
        justify-self: end;
        opacity: 0;
        padding: ${({ theme }) => theme.spacing}px;
    }
    :hover {
        background-color: #062b5414;
        > .MuiButtonBase-root  {
            opacity: 1;
        }
    }
`;

export const Title = styled.p`
    margin: 0;
    font-weight: bold;
    color: ${({ theme }) => theme.colors.blue};
    opacity: .87;
`;

export const MobileWrapper = styled.div`
    margin: 12px;
    padding: 12px;
    box-sizing: border-box;
    background-color: ${({ theme }) => theme.colors.paleBlue};
    border-radius: 6px;
`;

export const Label = styled.p`
    margin: ${({ theme }) => theme.spacing * 2}px 0;
    font-size: 12px;
    font-weight: bold;
    color: ${({ theme }) => theme.colors.darkBlueAlphaMedium};
    opacity: .87;
`;

export const GridWrapper = styled.div`
    margin-top: ${({ theme }) => theme.spacing * 2}px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 12px;
`;

export const Info = styled.p`
    font-size: 14px;
    margin: 0;
    color: ${({ theme }) => theme.colors.blue};
    opacity: .87;
`;

export const Wrapper = styled.div`
    display: grid;
    grid-template-columns: 1fr 30px;
    grid-column-gap: 16px;
    > .MuiButtonBase-root  {
        padding: 0 0 ${({ theme }) => theme.spacing}px 
            ${({ theme }) => theme.spacing}px;
    }
`;

export const StyledLink = styled(Link)`
    text-decoration: none;
    color: inherit;
`;
